import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

export const dateFormatterWithDayjs = (
    date: string | null,
    formatPattern = 'D MMMM',
    incomePattern = 'DD.MM.YYYY'
) => {
    if (date?.length === 0 || !date) {
        return null;
    }
    return dayjs(date, incomePattern).format(formatPattern);
};
